import { Account } from "views/account";
import { Password } from "views/account/password";
import { Profile } from "views/account/profile";

const Routes = [
  {
    path: "/admin/agency",
    view: Account,
    layout: "app",
    permission: "user",
    title: "Your Account",
  },
  {
    path: "/admin/agency/profile",
    view: Profile,
    layout: "app",
    permission: "user",
    title: "Your Profile",
  },
  {
    path: "/admin/agency/password",
    view: Password,
    layout: "app",
    permission: "user",
    title: "Change Password",
  },
];

export default Routes;
